import { useEffect, useMemo, useState } from "react";
import { ContentPageHeader } from "../../common/content-page-header/content-page-header";
import { LoadingIndicator } from "../../common/loading-indicator/loading-indicator";
import { AxnSessionsTableContainer } from "./axn-sessions-table-container/axn-sessions-table-container";
import { CardContainer } from "../../common/card-container/card-container";
import { resources } from "@constants/hardcoded-strings";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "@idw-types/state/application-state";
import { getAxnSessionsReduxRequest } from "@redux-requests/axn-sessions";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";

export const AxnSessionsContainer = () => {
    const dispatch = useDispatch();
    const {
        isLoadingAxnSessions,
        axnSessions,
        axnSessionsTableState
    } = useSelector((state: ApplicationState) => ({
        isLoadingAxnSessions: state.axnSessions.axnSessions.isLoading,
        axnSessions: state.axnSessions.axnSessions.axnSessions,
        axnSessionsTableState: state.tableSettings.axnSessions
    }));

    const [shouldLoadAxnSessions, setShouldLoadAxnSessions] = useState(true);

    useEffect(() => {
        if (!isLoadingAxnSessions && shouldLoadAxnSessions) {
            setShouldLoadAxnSessions(false);
            getAxnSessionsReduxRequest(dispatch)();
        }
    }, [isLoadingAxnSessions, shouldLoadAxnSessions]);

    const isLoading = useMemo(() => {
        return isLoadingAxnSessions;
    }, [isLoadingAxnSessions]);

    const isLoaded = useMemo(() => {
        return !!(
            !isLoading &&
            axnSessions &&
            !shouldLoadAxnSessions
        );
    }, [isLoading, axnSessions, shouldLoadAxnSessions]);

    return (
        <CardContainer isPageHeight={true}>
            <ContentPageHeader title={resources.pages.axnSessions.header} />
            <ContentPageBody isMaxWidth={true} isPageHeight={true}>
                {isLoaded && (
                    <AxnSessionsTableContainer
                        sessions={axnSessions}
                        tableState={axnSessionsTableState}
                        isPageHeight={true}
                    />
                )}
                {isLoading && (
                    <LoadingIndicator title={resources.common.loadingIndicatorText} />
                )}
            </ContentPageBody>
        </CardContainer>
    );
};